import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
export type ImageAssetFieldsFragment = { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null };

export const ImageAssetFieldsFragmentDoc = gql`
    fragment ImageAssetFields on directus_files {
  id
  filename_disk
  title
  width
  height
}
    `;